import { Controller } from "@hotwired/stimulus"

// Toggles the mobile check-pane bottom sheet.
export default class extends Controller {
  static targets = ["panel", "backdrop"]

  open(event) {
    event?.preventDefault()
    this.backdropTarget.classList.remove("hidden")
    this.panelTarget.classList.remove("translate-y-full")
  }

  close(event) {
    event?.preventDefault()
    this.backdropTarget.classList.add("hidden")
    this.panelTarget.classList.add("translate-y-full")
  }

  connect() {
    this._esc = (e) => { if (e.key === "Escape") this.close() }
    window.addEventListener("keydown", this._esc)
  }

  disconnect() {
    window.removeEventListener("keydown", this._esc)
  }
}
